module.exports = __webpack_public_path__ + "img/guarantee.a83ac71c.svg";